<template>
    <div class="portrait">
        <div class="table_wrap" style="height: 400px;">
            <el-table ref="pluginsTable" stripe border style="width: 100%" height="100%" max-height="100%" :data="pluginsTable" v-loading="pluginsTableLoading">
                <el-table-column type="index"></el-table-column>
                <el-table-column property="pluginName" label="插件名称" min-width="150"></el-table-column>
                <el-table-column property="pluginPreconditions" label="前置条件" width="150"></el-table-column>
                <el-table-column property="impactFunction" label="影响功能" width="180"></el-table-column>
                <el-table-column property="pluginDescriptionList" label="插件说明" min-width="150">
                    <template #default="{ row }">
                        <div v-for="(it, i) in row.pluginDescriptionList" :key="i">{{it}}</div>
                    </template>
                </el-table-column>
                <el-table-column property="isEnabled" label="状态" width="80">
                    <template #default="{ row }">
                        <div style="text-align: center;">{{row.isEnabled == 'Y' ? '已开启' : '未开启'}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="是否开启" prop="isEnabled" width="80">
                    <template #default="{ $index, row }">
                        <!-- <el-button type="primary" @click="addPortrait(row)" size="mini">编辑</el-button> -->
                        <el-switch v-model="row.isEnabled" active-value="Y" inactive-value="N" @change="switchChange($event, row, $index)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="beta版开启" width="80">
                    <template #default="{ $index, row }">
                        <el-button type="primary" @click="openBeta(row)" size="mini">开启</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        pluginsPropData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            pluginsTableLoading: false,
            pluginsTable: []
        };
    },
    created() {
        this.getPlugins();
    },
    methods: {
        async getPlugins() {
            this.pluginsTableLoading = true;
            let { enterpriseCode, enterpriseName } = this.pluginsPropData;
            const { data: res } = await this.$post(
                "/erpnew/account/c/reada46ceb/plugin/selectPluginListForMonitor", { enterpriseCode, enterpriseName }
            );
            this.pluginsTableLoading = false;
            if (res.code == 0) {
                this.pluginsTable = res.data.map(item => {
                    item.pluginDescriptionList = []
                    if (item.pluginDescription && item.pluginDescription.length > 0) {
                        if (item.pluginDescription.length == 1) {
                            item.pluginDescriptionList.push(item.pluginDescription[0] + '。')
                        } else {
                            for (var i = 0; i < item.pluginDescription.length; i++) {
                                item.pluginDescriptionList.push((i + 1) + '、' + item.pluginDescription[i] + (i == item.pluginDescription.length - 1 ? '。' : '；\n'))
                            }
                        }
                    }
                    return item
                });
            }
        },
        async switchChange(e, row, index) {
            console.log(e, index)
            if (row.isAllowOperation == 'N') {
                this.pluginsTable[index].isEnabled = e == 'Y' ? 'N' : 'Y'
                return this.$message({
                    message: '没有操作权限',
                    type: 'error',
                    showClose: true
                });
            }
            this.pluginsTableLoading = true;
            let obj = {
                enterpriseCode: this.pluginsPropData.enterpriseCode,
                enterpriseName: this.pluginsPropData.enterpriseName,
                pluginId: row.pluginId,
            }
            let url = '/erpnew/account/c/reada46ceb/plugin/closePluginListForMonitor'
            if (e == 'Y') url = '/erpnew/account/c/reada46ceb/plugin/openPluginListForMonitor'
            const { data: res } = await this.$post(url, obj);
            this.pluginsTableLoading = false
            if (res.code == 0) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.pluginsTable[index].isEnabled = e == 'Y' ? 'N' : 'Y'
                if (res.message) {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }
        },
        async openBeta(row) {
            console.log(row)
            this.pluginsTableLoading = true
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/plugin/openPluginListForMonitorByBeta', { pluginId: row.pluginId });
            this.pluginsTableLoading = false
            if (res.code == 0) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                if (res.message) {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            }
        }
    },
}
</script>
<style>
</style>